import { type ReactNode, useState } from 'react'
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

import { AuthBootstrap } from '../../features/auth'
import { ApiError } from '../../shared/api'
import { toast } from '../../shared/hooks'
import { useThemeSync, useUiLocaleSync } from '../hooks'

/** Needs the query client (site languages come from the API). */
function LocaleSync() {
  useUiLocaleSync()

  return null
}

export function AppProviders({ children }: { children: ReactNode }) {
  useThemeSync()
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 15_000,
            refetchOnWindowFocus: false,
            retry: (count, err) =>
              !(
                err instanceof ApiError &&
                err.status >= 400 &&
                err.status < 500
              ) && count < 2,
          },
          mutations: { retry: false },
        },
        queryCache: new QueryCache({
          onError: (err) => {
            if (
              err instanceof ApiError &&
              (err.status === 0 || err.status >= 500)
            )
              toast.error(err)
          },
        }),
      }),
  )

  return (
    <QueryClientProvider client={client}>
      <LocaleSync />
      <AuthBootstrap>{children}</AuthBootstrap>
    </QueryClientProvider>
  )
}
